import React, { useState, useEffect } from "react";
import useStyles from "./style";
import Header from "components/header";
import Footer from "components/footerUser";
import "assets/css/About.css";
import { Flex, Text, Box, Button } from "@chakra-ui/react";
import DashboardMobile from "../../assets/img/DashboardMobile.png";
import DashboardDesktop from "../../assets/img/DashboardDesktop.png";

const Dashboard = () => {
  const styles = useStyles();

  const [user, setUser] = useState();

  useEffect(() => {
    let localUser = localStorage.getItem("user");
    if (localUser) {
      setUser(JSON.parse(localUser));
    }
  }, []);

  return (
    <div>
      <div className={styles.app}>
        <Header active="dashboard" />
        <div className={styles.containerListItem}>
          {/* TAMPILAN DASHBOARD UNTUK SEMUA PERANGKAT */}
          <Flex
            direction={{ base: "column", md: "row" }}
            gap={5}
            // display={{ base: "flex", md: "none" }}
          >
            <Box
              flex={1}
              borderWidth={1}
              borderColor="#DCE3F2"
              borderRadius="lg"
              p={4}
              bg="white"
              boxShadow="sm"
            >
              <Flex
                justifyContent="space-between"
                alignItems="center"
                mb={3}
                gap={2}
              >
                <Text fontWeight={700} fontSize="lg" mb={4} color="black">
                  Cara Menggunakan Dashbaord
                </Text>
                {!user && (
                  <Button
                    size="sm"
                    bgColor="#0045B0"
                    color="white"
                    fontSize="xs"
                    px={3}
                    py={1}
                    borderRadius="5px"
                    onClick={() => {
                      if (user && user !== "guess") {
                        window.location.assign("/dashboard/profile");
                      } else {
                        localStorage.setItem(
                          "redirect_url",
                          "/dashboard/profile",
                        );
                        window.location.assign("/login");
                      }
                    }}
                    _hover={{ bg: "#00348a" }}
                    flexShrink={0}
                  >
                    Daftar Gratis
                  </Button>
                )}
              </Flex>

              <Flex direction="column" gap={1}>
                <ol>
                  <li>Silakan untuk Daftar/Login terlebih dahulu.</li>
                  <li>Di Dashboard kamu dapat melakukan edit Profile.</li>
                  <li>
                    Di Dashboard dapat melakukan pembelian layanan Profiling,
                    Matching dan Persona untuk diri sendiri.
                  </li>
                  <li>
                    Di Dashboard dapat melakukan pembelian layanan Profiling dan
                    Persona untuk Orang lain (user lain, colleague)
                  </li>
                  <li>Melihat status Pembelianmu</li>
                  <li>Menambah Teman dan Melihat list Friends</li>
                  <li>Menambah Colleague dan Melihat List Colleague</li>
                </ol>
              </Flex>
            </Box>

            <Box
              flex={1}
              borderWidth={{sm: 1, md: 0}}
              borderColor="#DCE3F2"
              borderRadius="lg"
              p={4}
              bg="white"
              boxShadow={{sm: "sm", md: "none"}}
            >
              <Text fontWeight={700} fontSize="lg" mb={4} color="black">
                Contoh Tampilan Dashboard
              </Text>

              <Box display={{ base: "block", md: "none" }}>
                <img src={DashboardMobile} alt="Dashboard Mobile" />
              </Box>
              <Box display={{ base: "none", md: "block" }}>
                <img src={DashboardDesktop} alt="Dashboard Desktop" />
              </Box>
            </Box>
          </Flex>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Dashboard;
